module.exports = __webpack_public_path__ + "img/760.9aff466c.png";